<script>
import Menu from '/src/components/header.vue';
import Rodape from '/src/components/rodape.vue';

export default {
  name: 'Qualidade',
  components: {
    Menu,
    Rodape,
  },
  data() {
    return {
      showModal: false, // Estado para controlar a visibilidade do modal
      selectedImage: '', // Caminho da imagem selecionada
    };
  },
  methods: {
    openModal(imageSrc) {
      this.selectedImage = imageSrc; // Define o caminho da imagem diretamente
      this.showModal = true; // Exibe o modal
    },
    closeModal() {
      this.showModal = false; // Oculta o modal
      this.selectedImage = ''; // Limpa a imagem selecionada
    },
  },
}
</script>

<template>
  <Menu></Menu>
  <div class="clientes">

    <div class="titulo">
      QUALIDADE
    </div>
    <div class="bloco1">
      <div class="texto">
        <ul>
          <li>Qualificação de Soldadores e Operadores de Soldagem, (ASME e AWS).</li>
          <li>Elaboração e Aprovação de Procedimentos de Soldagem (EPS/RQPS) e Tratamentos Térmicos, (ASME e AWS)</li>
          <li>Elaboração de Planos de Soldagem, IEIS's e Planos de Inspeção (ASME VIII div 1, ASME VIII div 2, AWS D1.1, B 31.1, B31.3, B31.4, B31.8, API 1104, API 650, API 620).</li>
          <li>Diligenciamento e Acompanhamento de Ensaios Mecânicos</li>
          <li>Elaboração de Procedimentos Técnicos de Fabricação, Pintura e Dimensional.</li>
          <li>Elaboração de Procedimentos de Ensaios não Destrutíveis (END) Nível 3 de EVS, LP, PM, UT.</li>
          <li>Elaboração de Plano da Qualidade.</li>
          <li>Elaboração de Data Book.</li>
          
        </ul>
      </div>
      <div class="imagens">
        <div class="image1">
          <img class="imagem" src="../assets/qualidade/qualidade1.jpg" alt=""
            @click="openModal(require('@/assets/qualidade/qualidade1.jpg'))">
          <img class="imagem" src="../assets/qualidade/qualidade2.jpeg" alt=""
          @click="openModal(require('@/assets/qualidade/qualidade2.jpeg'))">
        </div>
        <div class="image1">
          <img class="imagem" src="../assets/qualidade/qualidade3.jpg" alt=""
          @click="openModal(require('@/assets/qualidade/qualidade3.jpg'))">
          <img class="imagem" src="../assets/qualidade/databook.jpeg" alt=""
          @click="openModal(require('@/assets/qualidade/databook.jpeg'))">
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div v-if="showModal" class="modal" @click="closeModal">
    <div class="modal-content" @click.stop>
      <img :src="selectedImage" class="modal-image">
    </div>
  </div>

  <Rodape></Rodape>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
  .clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 0rem;
    min-height: 53.5vh;
  }

  .imagem {
    width: 8rem;
    height: 8rem;
    object-fit: cover;
    margin: 0rem 0.1rem;
    cursor: pointer;

  }

  .titulo {
    margin: 2rem;
    font-weight: bold;
    color: #2e74c4;
    font-size: 1.2rem;
  }

  .bloco1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .texto {
    width: 80%;
    margin-bottom: 1rem;
    font-size: 0.8rem
  }

  .imagens {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;

  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    width: 100%;
  }

  li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffffc5;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 550px;
    object-fit: cover;
}

.modal-image {
    width: 85%;
    height: auto;
    border-radius: 3px;
}
}

@media (min-width: 901px) {
  .clientes {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    width: 100vw;
    padding: 2rem;
    min-height: 53.5vh;
  }

  .imagem {
    width: 15rem;
    height: 10rem;
    object-fit: cover;
    margin: 0rem 0.1rem;
    cursor: pointer;

  }

  .titulo {
    margin: 2rem;
    font-weight: bold;
    color: #2e74c4;
    font-size: 1.2rem;
  }

  .bloco1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .texto {
    width: 40%;
  }

  .imagens {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  ul {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: center;
    width: 100%;
  }

  li {
    text-align: left;
    color: #444;
    line-height: 1.5rem;
  }
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000000e7;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 550px;
    object-fit: cover;
}

.modal-image {
    width: 85%;
    height: auto;
    border-radius: 3px;
}
}
</style>